module.exports = __webpack_public_path__ + "img/shade-mb.e3c0fb0d.png";